<template>
  <div>
    <input id="inputFile" type="file" accept="image/*" @change="previewImage">
    <div v-if="imageData.length > 0" class="upload">
      <img :src="imageData" alt="" />
    </div>
    <label for="inputFile"> <span> {{ inputName }} </span> </label>
  </div>
</template>

<script>
export default {
  name: 'previewImage',
  props: {
    inputName: String,
  },
  data() {
    return { imageData: '' };
  },
  methods: {
    previewImage(event) {
      let input = event.target;
      if (!input.files || !input.files[0]) { return; }
      let reader = new FileReader();
      reader.onload = (e) => {
        this.imageData = e.target.result;
      };
      reader.readAsDataURL(input.files[0]);
    },
  },
};
</script>
